// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2CGnd","col":"styles_col__1axH-"};